export default {
      id: "distance-usage",
      viewBox: "0 0 1423 1024",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#distance",
      toString: function () {
        return this.url;
      }
    }